export default __webpack_public_path__ + "static/media/1213 knife block A side.d3a985ce.png";